import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { euCountries } from './countries';
const MemberState = _ref => {
  let {
    country
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('member_state')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    disabled: true,
    type: "radio",
    label: t('eu_eea_state'),
    value: "true",
    checked: euCountries.includes(country),
    name: "has_made_claims_before",
    size: "md"
  }), /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    disabled: true,
    type: "radio",
    label: t('non_eu_eea_state'),
    value: "false",
    checked: !euCountries.includes(country),
    name: "has_made_claims_before",
    size: "md"
  })));
};
export default MemberState;